import type { TreeTag } from '#domains/tags';

export const filterHiddenChildren = (tags: TreeTag[]) => {
  return tags.filter(tag => {
    if (!tag.parentId) return true;

    const parentTag = tags.find(t => t.id === tag.parentId);

    return parentTag?.open === true; // Only show if parent open
  });
};
